import { Link } from 'react-router-dom'
import SiteLayout from '@/components/feature/SiteLayout'

export default function NotFound() {
  return (
    <SiteLayout>
      <div className="page-shell flex min-h-[62vh] flex-col items-center justify-center py-20 text-center">
        <p className="font-label text-6xl leading-none text-primary-200 md:text-8xl">404</p>
        <h1 className="mt-4 text-xl font-bold text-foreground-950 md:text-2xl">页面不存在</h1>
        <p className="mt-2 max-w-md text-sm leading-6 text-foreground-500">
          这个地址没有对应的页面，可能是链接输入有误，或者页面已经调整。可以回到首页或直接进入分类页继续浏览。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="whitespace-nowrap rounded-md bg-primary-800 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            返回首页
          </Link>
          <Link
            to="/category"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-800"
          >
            浏览影视分类
          </Link>
          <Link
            to="/search"
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-800"
          >
            搜索作品
          </Link>
        </div>
      </div>
    </SiteLayout>
  )
}